import React from 'react';
import './index.less';

export class WatchAnywhere extends React.Component {
	render() {
		return (
			<main className="watch-anywhere">
				<div className="branding">
					<p className="logo">Faithlife TV</p>
				</div>
				<div className="heading">
					<h1>Watch Anywhere</h1>
				</div>
				<div className="subheading">
					Thousands of hours of Bible documentaries, dramas, biographies, kids&#39; videos, and more
				</div>

				<div className="container">
					<div className="block web">
						<h4>Watch on the web</h4>
						<p>
							Stream Faithlife TV Plus videos anytime by visiting faithlifetv.com and logging in with your Logos
							account.
						</p>
						<div className="button-container last">
							<a href="/" className="button">
								Browse Faithlife TV
							</a>
						</div>
					</div>
				</div>
			</main>
		);
	}
}
